// @flow

export class RecaptchaExecutionError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'RecaptchaExecutionError';
  }
}
